import './Sorter.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCaretDown
  } from "@fortawesome/free-solid-svg-icons";

const states = [
    {
        value: "relevance",
        text: "Rilevanza",
        on: x => parseInt(x.Relevance)
    },
    {
        value: "popularity",
        text: "Popolarità",
        on: x => -parseInt(x.Popularity)
    },
    {
        value: "priceasc",
        text: "Prezzo Crescente",
        on: x => parseInt(x.PriceRank)
    },
    {
        value: "pricedesc",
        text: "Prezzo Decrescente",
        on: x => -parseInt(x.PriceRank)
    },
]

function Sorter(props) {
    return (
        <div className='sorterContainer'>
            <select className='sorter' name="order" onChange={e => props.onChange(states.find(x => x.value === e.target.value))} value={props.selected === null ? "relevance" : props.selected.value}>
            {
                states.map(x => <option key={x.value} value={x.value}>{x.text}</option>)
            }
            </select>
            <FontAwesomeIcon icon={faCaretDown}/>
        </div>
        
    )
}

export default Sorter